import { Typography } from "@/components/ui-v2";
import { useBasicData, useQueryWithResponseHandler } from "@/hooks";
import { getConnectionNodesTyped } from "@/utils/relay";

import { SessionItem } from "./components/SessionItem/SessionItem";
import { GetRecentSessions } from "./queries.graphql";

// The homepage's "My Sessions" list asks for the same connection with the same
// arguments, and graphcache merges their pages, so the cached list can be longer.
const RECENT_SESSIONS_LIMIT = 5;

export const RecentSessions = () => {
  const { activeWorkspace } = useBasicData();
  const canViewSessions =
    activeWorkspace?.name &&
    activeWorkspace?.myPermissions?.includes("session:view");
  const { data, error } = useQueryWithResponseHandler({
    query: GetRecentSessions,
    pause: !canViewSessions,
    variables: {
      workspaceName: activeWorkspace?.name,
      getSessionsInput: {
        status: ["ACTIVE"],
        first: RECENT_SESSIONS_LIMIT,
        mineOnly: true,
        filterEmpty: true,
        sorting: [
          {
            field: "lastInteractedAt",
            direction: "DESC",
          },
        ],
      },
    },
  });

  const sessions = data?.workspace?.sessions
    ? getConnectionNodesTyped(data.workspace.sessions).slice(
        0,
        RECENT_SESSIONS_LIMIT,
      )
    : [];

  if (error || !activeWorkspace || !sessions || sessions.length === 0) {
    return null;
  }

  return (
    <nav>
      <Typography
        fontWeight="600"
        variant="micro"
        color="secondary.3"
        sx={{ display: "inline-block", mt: 4, mb: 2, ml: 2.5 }}
      >
        Recent Sessions
      </Typography>
      {sessions.map((session) => (
        <SessionItem
          key={session.id}
          name={session.name}
          to={`/${activeWorkspace.name}/session/${session.id}`}
          iconUrl={session.previewUrls?.[0] ?? undefined}
        />
      ))}
    </nav>
  );
};
